module.exports = __webpack_public_path__ + "static-portal/img/60-1.dde3d47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/60-1.jpg
// module id = 4Ti0
// module chunks = 4